import Container from 'mango-ui/layout/Container';
import * as React from 'react';
import { IRegion } from '../../api/operation/region';
import {MenuItem, Select} from "@material-ui/core";
const style = require('./style.less');

export interface IRegionListProps {
    regions: IRegion[];
    selectedRegion: IRegion;
    regionInfo: IRegion;
    onRegionSelected: (region: string) => void;
    editing: boolean;
    onToggleEditing: IFunction;
    onCancelEditing: IFunction;
}

export const ShowRegionInfo = ({ regions, selectedRegion, onRegionSelected }: IRegionListProps) => {
    return (
        <div className={style.container}>
            <h2 className={style.title}>{!selectedRegion ? '请先选择大区' : `${selectedRegion.name}`}&nbsp;</h2><br/>
            <div className={style.content}>
                <div className={style.left}>大区面积:{!selectedRegion ? '' : `${(selectedRegion.area*0.000001).toFixed(2)}km2`}&nbsp;</div>
                <div className={style.left}>禁停区数量:{!selectedRegion ? '' : `${selectedRegion.forbiddenAreaCount}个`}&nbsp;</div>
            </div>
            <div className={style.content}>
                <span className={style.left}>停车区数量:{!selectedRegion ? '' : `${selectedRegion.parkingLotsCount}个`}&nbsp;</span>
                <span className={style.left}>禁行区数量:{!selectedRegion ? '' : `${selectedRegion.prohibitedAreaCount}个`}&nbsp;</span>
            </div>
            <div className={style.left}>路网长度:{!selectedRegion ? '' : `${(selectedRegion.roadNetLength*0.001).toFixed(2)}km`}&nbsp;</div>
        </div>
    );
};

export default ShowRegionInfo;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/RegionInfoView/RegionInfoView.tsx